module.exports = function() {
  return new Worker(__webpack_public_path__ + "f3d44235975cb321f630.worker.js");
};